import { updateBudget} from '@/api/advertiser'
import moment from 'moment';

export default {
    components: {
    },
    props: {
        showCreateBudgetForm: {
            type: Boolean,
            required: true
        },
        model: {
            type: Object,
            default: () => null
        }
    },
    data () {
        return {
            labelCol: { span: 4 },
            wrapperCol: { span: 18 },
            loading: false,
            rules: {
                // email: [ { required: true, message: '请填写邮箱', trigger: 'change' }],
            },
            title: '修改预算',
        }
    },
    computed: {
        actType() {
            return this.model.id ? '修改' : '添加'
        }
    },
    mounted () {
        console.log('进入',this.model)
    },
    methods: {
        submit() {
            this.$refs.form.validate(valid => {
                if (!valid) {
                    return false
                }
                this.storeOrUpdate()
            });
        },
        storeOrUpdate() {
            this.loading = true
            console.log(this.model)
            updateBudget(this.model,this.model.id>0?this.model.id:this.model.ids).then(res => {
                this.$message.destroy()
                if (res && res.code === 0) {
                    this.$message.success('更新成功')
                    this.$emit('success')
                    this.close()
                } else {
                    this.$message.error(res.message)
                }
                this.loading = false
            }).catch(() => {
                this.loading = false
            })
        },
        close() {
            this.$refs.form.resetFields()
            this.$emit('update:showCreateBudgetForm', false)
            this.$emit('success')
        },
        moment,
    }
}
